import { useCallback, useState, useImperativeHandle, forwardRef } from 'react';
import { Form, Input } from 'antd';
const TextArea = Input.TextArea;

//* HOC's
import { withLanguageContext, withDataContext } from 'context';

//* Components
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
import FormContainer from 'components/common/FormContainer';

//* Style
import FeedbackPopupStyle from './style';

const FeedbackPopup = forwardRef(({ feedbackData, translate, addFeedback, closePopup }, ref) => {
	//! State
	const [isSend, setIsSend] = useState(false);

	useImperativeHandle(ref, () => ({
		handleClose: onFinish,
	}));

	const onFinish = useCallback(
		(values) => {
			if (!isSend) {
				values && setIsSend('loading');

				return addFeedback({
					id: feedbackData.typeId,
					pageType: feedbackData.type,
					rating: feedbackData.rating == 'like' ? 1 : 0,
					content: values?.feedback,
				})
					.then(() => {
						if (!values) {
							closePopup();
						} else {
							setIsSend(true);
						}
					})
					.catch((err) => {
						return Promise.reject(err);
					});
			} else {
				closePopup();
			}
		},
		[isSend]
	);

	return (
		<>
			<FeedbackPopupStyle />

			{isSend && isSend !== 'loading' ? (
				<div className='success-container'>
					<div className='success-panel'>
						<Icon
							name={'check'}
							className={'success-icon'}
						/>
					</div>
					<div className='success-panel-text'>
						<Text
							className={'h6 font-ping-medium'}
							text={'feedbackSuccessText'}
						/>
					</div>
				</div>
			) : (
				<div className='feedback-content-wrap'>
					<Text
						className={'h5 font-ping-medium text-center'}
						text={'feedbackPopupTitle'}
					/>

					<FormContainer onFinish={onFinish}>
						<FormItem
							name={'feedback'}
							required={false}>
							<TextArea
								rows={5}
								type={'text'}
								placeholder={`${translate('feedbackFieldPlaceholder')}`}
							/>
						</FormItem>

						<div className='feedback-button-block'>
							<Form.Item
								noStyle
								shouldUpdate={(prevValues, curValues) => prevValues.feedback != curValues.feedback}>
								{({ getFieldValue }) => (
									<Button
										text={'submit'}
										color={'ColorBigStone'}
										className={'feedback-btn'}
										background={'ColorApricot'}
										hoverColor={'ColorBigStone'}
										disabled={!getFieldValue('feedback')}
										isBtnLoad={isSend === 'loading'}
										hoverBackground={'ColorYellowTan'}
										hoverBorderColor={'ColorYellowTan'}
									/>
								)}
							</Form.Item>
						</div>
					</FormContainer>
				</div>
			)}
		</>
	);
});

export default withLanguageContext(withDataContext(FeedbackPopup, ['addFeedback']), ['translate']);
